export default __webpack_public_path__ + "static/screeny-110-gc-6-ea0f8f8aaed597da839d485d04922081.jpg";